/**
 * A „később aktuális” lead újrahívási hónapja: 'YYYY-MM-01' dátum (az adatbázis a hónap első napját tárolja).
 * A választható hónapok a folyó (budapesti) hónaptól 24 hónapig tartanak, mint az adatbázis ellenőrzése
 * (leads_ujrahivas_or): a 2 év érintetlenség utáni törlés előbb jönne, mint a későbbi újrahívás.
 */
export const UJRAHIVAS_MAX_HONAP = 24;

const BP_HONAP = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Budapest', year: 'numeric', month: '2-digit' });
const HONAP_NEV = new Intl.DateTimeFormat('hu-HU', { year: 'numeric', month: 'long', timeZone: 'UTC' });

/** A folyó budapesti hónap első napja: 'YYYY-MM-01'. */
export function folyoHonap(nowMs: number): string {
  const r = Object.fromEntries(BP_HONAP.formatToParts(nowMs).map((p) => [p.type, p.value]));
  return `${r.year}-${r.month}-01`;
}

/** A hónap eltolva n hónappal: '2026-11-01' + 3 → '2027-02-01'. */
export function honapEltolas(honap: string, n: number): string {
  const [e, h] = honap.split('-').map(Number) as [number, number];
  const d = new Date(Date.UTC(e, h - 1 + n, 1));
  return d.toISOString().slice(0, 10);
}

/** „2026. november” (a dátum hónapja, napja nem számít). */
export function honapCimke(honap: string): string {
  const [e, h] = honap.split('-').map(Number) as [number, number];
  return HONAP_NEV.format(new Date(Date.UTC(e, h - 1, 1)));
}

/** A választható hónapok: a folyó hónap és az azt követő 24. */
export function valaszthatoHonapok(nowMs: number): { ertek: string; cimke: string }[] {
  const most = folyoHonap(nowMs);
  return Array.from({ length: UJRAHIVAS_MAX_HONAP + 1 }, (_, i) => {
    const ertek = honapEltolas(most, i);
    return { ertek, cimke: honapCimke(ertek) };
  });
}

/** Esedékes: az újrahívás hónapja a folyó hónap vagy korábbi. */
export function esedekes(honap: string | null, nowMs: number): boolean {
  return honap !== null && honap.slice(0, 10) <= folyoHonap(nowMs);
}
